import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import { Router, RouterStateSnapshot } from '@angular/router';
@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  user: any = {};
  _redirectURL: string = '/auth/login'

  constructor(private router: Router) {
    
  }
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // add a custom header
    if (localStorage.getItem('currentUser') != null)
      this.user = JSON.parse(localStorage.getItem('currentUser'));

    if (this.user != null && this.user.auth_token != null) {    
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.user.auth_token}`
        }
      });
    }


     
    return next.handle(request).do((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        // do stuff with response if you want
      }
    }, (err: any) => {
      if (err instanceof HttpErrorResponse) {
        if (err.status === 401) {
          //invalidate local user
          localStorage.clear();
          // redirect to the login route
          this.router.navigate([this._redirectURL], {  });

        }
      }
    });
  }
}
